import React from 'react';
import MobileHeader from '../components/layout/mobileHeader';
import BottomNav from '../components/layout/bottomNav';
import './map.css';

import mapImage from '../assets/imgs/map.png';

const Map = () => {

  return (
    <main className="mapPage">
      <MobileHeader />
      <section className="mapContainer">
        <img src={mapImage} alt="CIBF venue map" className="mainMapImage" />
      </section>

      <BottomNav activePage="map" />
    </main>
  );
};

export default Map;